export default {"src":"/_next/static/media/TOAST_INFO.7092888c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};